<div class="df-wrapper">

  @if (svc.rootGroup()) {

    <!-- ── Form ────────────────────────────────────────────────────────── -->
    <form
      [formGroup]="svc.rootGroup()!"
      novalidate
      class="df-form"
    >

      @for (category of svc.visibleCategories(); track category.key) {
        <app-category-accordion [category]="category"/>
      }

      <!--
        Blocco accettazioni globali (fuori dall'accordion).
        Visibile solo se config.acceptances ha almeno un elemento.
        Il componente stesso gestisce il @if internamente.
      -->
      <app-acceptances-block
        [acceptancesSectionTitle]="svc.config()?.acceptancesSectionTitle ?? 'Accettazioni e consensi'"
        [acceptancesSectionDescription]="svc.config()?.acceptancesSectionDescription ?? ''"
        [acceptancesSectionNote]="svc.config()?.acceptancesSectionNote ?? ''"
      />

    </form>
  }

</div>
